/* eslint-disable quotes */
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    nl: {
        translation: {
            login: {
                login: 'Inloggen',
                welcome: 'WELKOM BIJ DE CSE TOOL',
                credentials: 'Vul uw gegevens in om in te loggen.',
                passwordForgot: 'Wachtwoord vergeten?',
                loggedInAs: 'Ingelogd als',
                passwordReset: 'Wachtwoord herstel',
                passwordResetText: 'Voer hieronder uw nieuwe wachtwoord in',
                goBackToLogin: 'Ga terug naar het loginscherm.',
                submit: 'Opslaan',
                passwordSaved: 'Wachtwoord ingesteld.',
                passwordSavedText: 'Je nieuwe wachtwoord is succesvol ingesteld.',
                activateAccount: 'Account activeren',
                activateAccountText: 'Voer hieronder uw nieuwe wachtwoord in.',
                send: 'Verzenden',
                accountActivated: 'Account geactiveerd.',
                accountActivatedText: 'Bedankt voor het activeren van uw account. U kunt nu inloggen.',
                forgotPassword: 'Wachtwoord vergeten',
                forgotPasswordText:
                    'Voer hieronder uw e-mailadres in, en wij versturen u een mail met verdere instructies.',
                resendActivationMailSuccess: 'Activatiemail verzonden.',
                resendActivation: 'Verstuur activatiemail opnieuw',
                emailSend: 'Email is verstuurd',
                emailSendText: 'We hebben een mail gestuurd met verdere instructies. U kunt dit scherm sluiten.',
                username: 'Gebruikersnaam',
                password: 'Wachtwoord',
                passwordConfirm: 'Wachtwoord bevestigen',
                chooseLanguage: 'Kies een taal',
                email: 'Email',
            },
            errors: {
                RoleNotFound: 'De rol kon niet gevonden worden. Dit is een server error.',
                DuplicateUserName: 'Er bestaat al een gebruiker met dit e-mailadres.',
                UserNotFound: 'Gebruiker kon niet gevonden worden.',
                InvalidResetToken: 'Deze link is niet meer geldig.',
                InvalidActivationToken: 'Deze link is niet meer geldig.',
                WeekOrYearNotFound: 'De week of het jaar kan niet uit de bestandsnaam worden gelezen.',
                NoCSVFormat: 'Het bestand moet in CSV formaat zijn.',
                WrongDataFile: 'De data in het bestand heeft niet de verwachte structuur.',
                AccountBlocked: 'Uw account is geblokkeerd.',
                IncorrectPassword: 'Het wachtwoord is incorrect.',
                PasswordRequires: 'Het wachtwoord moet <> bevatten.',
                PasswordRequiresNonAlphanumeric: 'een bijzonder teken',
                PasswordRequiresDigit: 'een cijfer',
                PasswordRequiresUpper: 'een hoofdletter',
                PasswordRequiresLower: 'een kleine letter',
                VehicleNotFound: 'Voertuig kon niet gevonden worden.',
                VehicleAddFailed: 'Voertuig kon niet toegevoegd worden.',
                LicensePlateAlreadyExists: 'Er bestaat al een voertuig met dit kenteken.',
                LicensePlateOrMendrixIdAlreadyExists: 'Er bestaat al een voertuig met dit kenteken of dit Mendrix Id.',
                MendrixIdAlreadyExists: 'Er bestaat al een voertuig met dit Mendrix Id.',
                VehicleDeleteFailed: 'Voertuig kon niet verwijderd worden.',
                ServerError: 'Er is iets fout gegaan, neem contact op met support.',
                SomethingWrong: 'Er is iets fout gegaan.',
                UnknownUserType: 'Gebruikers rol onbekend.',
                RequiredField: 'Verplicht veld',
                InvalidEmail: 'Ongeldig e-mailadres',
                NonidenticalPassword: 'Wachtwoorden komen niet overeen.',
                NoWeekstaten: 'Weekstaten van deze week zijn nog niet gegenereerd!',
                NoRevenue: 'Omzetten van deze week zijn nog niet geüpload!',
                NoWeekstatenAndRevenue: 'Weekstaten and omzetten van deze week zijn nog niet gegenereerd/geüpload!',
                MailIsConfirmed: 'Email is al bevestigd.',
                EndTimeMustBeLater: 'Eindtijd moet later dan de starttijd zijn.',
                MustBePositiveNumber: 'Moet een positief getal zijn.',
                MustBeNumberGreaterOrEqualZero: 'Moet een bedrag zijn dat groter is dan of gelijk is aan nul.',
                MustBeIntegerGreaterOrEqualZero: 'Moet een geheel getal zijn dat groter is dan of gelijk is aan nul.',
                CustomerNotFound: 'Klant kon niet gevonden worden.',
                CouldNotUpdateCustomer: 'Klant kon niet bijgewerkt worden.',
                CustomerAlreadyExists: 'Er bestaat al een klant met dit id.',
                CouldNotAddCustomer: 'Klant kon niet toegevoegd worden.',
                NoArticleGroupsInCustomer: 'Klant {{name}} heeft geen Artikelgroepen. Voeg eerst een Artikelgroep toe.',
                NoCanArticleGroupsInCustomer:
                    'Er is geen Artikelgroep met type "Cans" op {{date}} gevonden. Voeg eerst een Artikelgroep toe of wijzig de start-/einddatum.',
                NoEndArticleGroupsInCustomer:
                    'Er is geen Artikelgroep met type "Ends" op {{date}} gevonden. Voeg eerst een Artikelgroep toe of wijzig de start-/einddatum.',
                NoArticleGroupsForMaterial:
                    'Er is geen Artikelgroep gevonden voor matriaalbeschrijving {{materialDescription}}. Controleer cel F{{row}} en/of de Artikelgroepen',
                NoDateFound: 'Datum kon niet gevonden worden in het bestand.',
                WrongPlantName: 'De locatiecode in het bestand komt niet overeen met deze klant.',
                UnknownDataFormat: 'We konden er niet achter komen wat voor bestand je probeerde te uploaden.',
                CouldNotDeleteArticleGroup:
                    'Het is niet mogelijk om {{AGName}} artikelgroep te verwijderen, aangezien er data aan gekoppeld is.',
                CouldNotChangeArticleGroupStartDate:
                    'Er is data gekoppeld aan {{AGName}} artikelgroep voor de datum - {{earliestDateLinkedToAG}} - die is ingevoerd.',
                CouldNotChangeArticleGroupEndDate:
                    'Er is data gekoppeld aan {{AGName}} artikelgroep na de datum - {{latestDateLinkedToAG}} - die is ingevoerd.',
                MustBeInsideEwiValidityPeriod:
                    'De datum moet binnen de geldigheidsperiode voor het gekozen extra werk item vallen: van {{EWIStartDate}} tot {{EWIEndDate}}.',
                ExtraWorkEntryNotFound: 'De extra werk-invoer kond niet worden gevonden.',
                CouldNotDeleteExtraWorkItem:
                    'Het is niet mogelijk om {{EWIDescription}} extra werkitem te verwijderen, aangezien er data aan gekoppeld is.',
                CouldNotChangeExtraWorkItemStartDate:
                    'Er is data gekoppeld aan {{EWIDescription}} extra werkitem voor de datum {{eariestEntryDate}} die is ingevoerd.',
                CouldNotChangeExtraWorkItemEndDate:
                    'Er is data gekoppeld aan {{EWIDescription}} extra werkitem na de datum {{latestEntryDate}} die is ingevoerd.',
                ThisDateOverlapWithAG: 'Deze datum zorgt voor overlap met artikelgroep {{OtherAGName}}.',
                NoXlsxFile: 'Bestand heeft niet de .xlsx-extensie',
                CouldNotGetInformationFromTLN: 'Kon geen informatie krijgen van TLN',
                MissingTLNResponse:
                    'Er is een probleem met de locatiegegevens van de volgende voertuigen: {{formattedVehicles}}',
                MissingTLNResponseEntry: '{{number}}, order {{orderKey}} om {{date}}',
            },
            explanations: {
                MendriX:
                    'Haal alle gegevens uit MendriX op (de data van de vorige week is pas op dinsdag beschikbaar).',
                JustNeedsExcel: 'De bestanden moeten .xlsx-bestanden zijn',
                JustNeedsOneExcel: 'De bestand moeten .xlsx-bestanden zijn',
                JustNeedsSomeExcel: 'De bestanden moeten .xls of .xlsx-bestanden zijn',
                UploadTemplateFiles: 'Je dient hieronder enkele templates te uploaden',
                UploadExportStilstandTemplateFile: 'Je dient hieronder export stilstand template te uploaden.',
                DownloadAllResults:
                    'Hier kun je alle bestanden downloaden: weekstaten, resultaatoverzicht, samenvatting en kilometersamenvatting. Dit kan alleen als de gegevens voor de betreffende week al uit MendriX zijn gehaald.',
                DownloadStilstand: 'Hier kun je de stilstand van een gekozen jaar downloaden.',
                ValidationErrors:
                    'Er zijn één of meer voertuigen met ongeldige tijdstippen. Deze voertuigen zullen niet worden opgeslagen',
                UploadMovementsAndStock: 'Upload voorraad- en mutatiebestanden',
                DownloadWeekendHours: 'Hier kun je de weekenduren voor een gekozen periode downloaden.',
            },
            roles: {
                Admin: 'Beheerder',
                TransportPL: 'TransportPL',
                TransportPlanning: 'TransportPlanning',
                TransportNL: 'TransportNL',
                Warehousing: 'Warehousing',
            },
            statuses: {
                Pending: 'In afwachting',
                Active: 'Actief',
                Blocked: 'Geblokkeerd',
            },
            general: {
                MendriX: 'MendriX',
                VariableOverview: 'Overzicht variabelen',
                Revenue: 'Omzet',
                VehicleRevenues: 'Overzicht omzetgegevens voertuigen',
                Comparison: 'Vergelijken',
                ComparisonTitle: 'Kilometerstaten met Rittenlijsten vergelijken',
                Normalize: 'Normaliseren',
                CseTool: 'CSE Tool',
                Loading: 'Aan het laden...',
                Save: 'Opslaan',
                Variables: 'Variabelen',
                Cancel: 'Annuleren',
                Submit: 'Opslaan',
                Confirm: 'Bevestigen',
                Users: 'Gebruikers',
                Weekstaten: 'Weekstaten',
                Vehicles: 'Voertuigen',
                VehicleOvertimes: 'Weekend uren',
                StationaryTool: 'Stilstand',
                Warehousing: 'Warehousing',
                ChangesSaved: 'Wijzigingen opgeslagen',
                ChangesNotSaved: 'Wijzigingen konden niet worden opgeslagen',
                Till: 'Tot',
                Saturday: 'Zaterdag',
                Sunday: 'Zondag',
                Holidays: 'Feestdagen',
                NotesAdmin: 'Notities NL',
                NotesUser: 'Notities PL',
                Total: 'Totaal',
                SelectWeek: 'Selecteer week',
                SelectMonth: 'Selecteer maand',
                SelectYear: 'Selecteer jaar',
                Search: 'Zoeken',
                Busy: 'Bezig...',
                Generate: 'Genereren',
                And: 'En',
                Page: 'Pagina',
                Of: 'van',
                Refresh: 'Verversen',
                Time: 'Tijd',
                ForExampleAbbr: 'bijv.',
                Month: 'Maand',
            },
            variables: {
                Variable: 'Variabele',
                Value: 'Waarde',
                Type: 'Type',
                NoVariablesFound: 'Geen variabelen gevonden',
                types: {
                    Currency: 'Bedrag',
                },
                names: {
                    DrivenDayTariffTruck: 'Gereden dagtarief truck',
                    DrivenDayTariffCombi: 'Gereden dagtarief combi',
                    NonDrivenDayTariffTruck: 'Niet-gereden dagtarief truck',
                    NonDrivenDayTariffCombi: 'Niet-gereden dagtarief combi',
                    WeekendHoursTariff: 'Weekendurentarief',
                },
            },
            user: {
                AddUser: 'Gebruiker toevoegen',
                EditUser: 'Gebruiker wijzigen',
                UserOverview: 'Gebruikersoverzicht',
                FirstName: 'Voornaam',
                LastName: 'Achternaam',
                FullName: 'Volledige naam',
                Role: 'Rol',
                Status: 'Status',
                NoUsersFound: 'Geen gebruikers gevonden',
                Email: 'Email',
                SelectRole: 'Selecteer rol',
            },
            vehicle: {
                Vehicle: 'Voertuig',
                Charter: 'Charter',
                Dutch: 'Dutch',
                Polish: 'Polish',
                AddVehicle: 'Voertuig toevoegen',
                EditVehicle: 'Voertuig bewerken',
                VehicleOverview: 'Voertuigen overzicht',
                Number: 'Voertuignummer',
                LicensePlate: 'Kenteken',
                Type: 'Type',
                NoVehiclesFound: 'Geen voertuigen gevonden',
                ConfirmDelete: 'Weet je zeker dat je dit voertuig wilt verwijderen?',
                NoVehicleChosen: 'Geen voertuig gekozen',
                VolumeType: 'Volumetype',
                Truck: 'Truck',
                Combi: 'Combi',
                ExemptedGermanToll: 'Vrijstelling van Duitse tol',
            },
            weekstaten: {
                GenerateWeekstaten: 'Weekstaten genereren',
                UploadRittenlijst: 'Upload rittenlijsten',
            },
            resultsOverview: {
                GenerateResultsOverview: 'Genereer resultaat overzicht',
                GenerateSummaryPerWeek: 'Genereer samenvatting per week',
                UploadResultsFile: 'Upload resultaat bestand',
            },
            kilometerstaten: {
                NormalizeKS: 'Normaliseer kilometerstaten',
                UploadOmzetlijst: 'Upload omzetlijst',
            },
            kms: {
                UploadKmsFile: 'Upload kilometersamenvatting template',
            },
            vehicleRevenue: {
                UploadOmzetlijst: 'Upload omzetlijst',
                GenerateTurnover: 'Omzetgegevens voertuigen genereren',
                OrderKey: 'Order #',
                RelationName: 'Naam relatie',
                FirstTaskPlace: 'Plaats, eerste taak',
                FirstTaskPostalCode: 'Postcode, eerste taak',
                FirstTaskTimestamp: 'Gepland, eerste taak',
                LastTaskTimestamp: 'Gepland, laatste taak',
                LastTaskPlace: 'Plaats, laatste taak',
                LastTaskPostalCode: 'Postcode, laatste taak',
                NumberOfTasks: 'Takenaantal',
                PurchaseCost: 'Inkoopbedrag',
                PurchaseCostExclBTW: 'Excl. BTW',
                PurchaseCostExclBTWLeft: 'Over',
                Total: 'totaal',
            },
            stilstand: {
                Number: 'Voertuignummer',
                LicensePlate: 'Kenteken',
                Monday: 'Maandag',
                Tuesday: 'Dinsdag',
                Wednesday: 'Woensdag',
                Thursday: 'Donderdag',
                Friday: 'Vrijdag',
                Saturday: 'Zaterdag',
                Sunday: 'Zondag',
                SelectAVehicle: 'Selecteer een voertuig',
                SpecialNotes: 'Extra / speciale opmerkingen',
                SelectStandartReason: 'Selecteer standaard reden',
            },
            mendrix: {
                RetrieveDataShort: 'Haal gegevens op',
                RetrieveData: 'Haal alle relevante informatie op uit MendriX',
                CheckStatus: 'Check MendriX-status',
                TerminateRetrieval: 'Stop ophalen van gegevens',
                SomethingWentWrong: 'Er is iets fout gegaan',
                CancelledByUser: 'Geannuleerd door gebruiker',
                Failed: 'Mislukt',
                Starting: 'Begint nu',
                Finished: 'Klaar',
            },
            warehousing: {
                tabs: {
                    InformatieTab: 'Informatie',
                    UploadTab: 'Uploads',
                    DownloadTab: 'Downloads',
                    ExtraWorkTab: 'Extra werk',
                },
                UploadFile: 'Bestanden uploaden',
                UploadStockFile: 'Voorraadbestand uploaden',
                Import: 'Importeer',
                ImportSuccessful: 'De import is geslaagd',
                timeline: {
                    title: 'Tijdlijn',
                    error: 'Er is iets fout gegaan bij het ophalen van de tijdlijn',
                    viewAllChanges: 'Bekijk alle wijzigingen',
                    hideChanges: 'Verberg wijzigingen',
                    to: 'naar',
                    categories: {
                        Downloads: 'Downloads',
                        Uploads: 'Uploads',
                        Customers: 'Klanten',
                        ExtraWorkEntries: 'Extra werk',
                        Notes: 'Notities',
                    },
                    customNote: {
                        addNote: 'Notitie toevoegen',
                        placeholder: 'Typ hier je notitie...',
                        error: 'Er is iets fout gegaan bij het toevoegen van de notitie',
                    },
                    CustomerAdded: {
                        title: 'Klant <strong>{{name}}</strong> is toegevoegd.',
                    },
                    CustomerDeleted: {
                        title: 'Klant <strong>{{name}}</strong> is verwijderd.',
                    },
                    CustomerUpdated: {
                        title: 'De volgende velden van klant <strong>{{name}}</strong> zijn gewijzigd:',
                        fields: {
                            Added: 'is toegevoegd',
                            Deleted: 'is verwijderd',
                            Updated: 'is gewijzigd',

                            Name: 'Naam',
                            Address: 'Adres',
                            PlantName: 'Locatiecode',
                            InvoiceLogicType: 'Logica',
                            PriceLaborSaturdaySupervisor: 'Prijs arbeid zaterdag (supervisor)',
                            PriceLaborSundayHolidaySupervisor: 'Prijs arbeid zondag/feestdag (supervisor)',
                            PriceLaborSaturdayForklift: 'Prijs arbeid zaterdag (forklift)',
                            PriceLaborSundayHolidayForklift: 'Prijs arbeid zondag/feestdag (forklift)',
                            SurchargeInHandlingSat: 'Toeslag voor handling in (zaterdag)',
                            SurchargeInHandlingSun: 'Toeslag voor handling in (zondag)',
                            SurchargeOutHandlingSat: 'Toeslag voor handling uit (zaterdag)',
                            SurchargeOutHandlingSun: 'Toeslag voor handling uit (zondag)',

                            ArticleGroup: 'Artikelgroep',
                            ArticleGroupType: 'Type',
                            StartDate: 'Startdatum',
                            EndDate: 'Einddatum',
                            FixedQuantity: 'Vaste hoeveelheid (in pallets)',
                            VariableQuantity: 'Variabele hoeveelheid (in pallets)',
                            PricePerPalletFixed: 'Prijs per pallet (vast)',
                            PricePerPalletVariable: 'Prijs per pallet (variabel)',
                            PricePerPalletHandlingIn: 'Prijs per palletbehandeling (in)',
                            PricePerPalletHandlingOut: 'Prijs per palletbehandeling (uit)',

                            ExtraWorkItem: 'Extra werkitem',
                            Description: 'Beschrijving',
                            PricePerUnit: 'Prijs per eenheid',
                            Unit: 'Eenheid',
                        },
                    },
                    DocumentDownloaded: {
                        title: 'Document <strong><fileLink>{{name}}</fileLink></strong> is gedownload.',
                    },
                    DocumentUploaded: {
                        title: 'Document <strong><fileLink>{{name}}</fileLink></strong> is geüpload voor klant <strong>{{customer}}</strong>. Het bevatte <strong>{{dataCount}}</strong> gegevens tussen <strong>{{fromDate}}</strong> en <strong>{{toDate}}</strong>.',
                    },
                    ExtraWorkEntryAdded: {
                        title: 'Data voor extra werk item <strong>{{extraWorkItem}}</strong> is toegevoegd:',
                    },
                    ExtraWorkEntryDeleted: {
                        title: 'Data voor extra werk item <strong>{{extraWorkItem}}</strong> is verwijderd:',
                    },
                    ExtraWorkEntryUpdated: {
                        title: 'Data voor extra werk item <strong>{{extraWorkItem}}</strong> is gewijzigd:',
                        fields: {
                            ExtraWorkItem: 'Extra werkitem',
                            Timestamp: 'Datum',
                            Quantity: 'Aantal',
                            Remark: 'Opmerking',
                        },
                    },
                },
                downloads: {
                    export: {
                        description:
                            'Exporteer data voor klant <strong>{{name}}</strong> binnen de geselecteerde periode.',
                        fromDate: 'Van datum (inclusief)',
                        toDate: 'Tot datum (inclusief)',
                        export: 'Exporteer',
                    },
                },
            },
            customer: {
                AddCustomer: 'Klant toevoegen',
                ExportAllCustomers: 'Exporteer alle klanten',
                EditCustomer: 'Klant bewerken',
                Name: 'Naam',
                PlantName: 'Locatiecode',
                PriceLaborSaturdaySupervisor: 'Prijs arbeid zaterdag (supervisor)',
                PriceLaborSundayHolidaySupervisor: 'Prijs arbeid zondag/feestdag (supervisor)',
                PriceLaborSaturdayForklift: 'Prijs arbeid zaterdag (forklift)',
                PriceLaborSundayHolidayForklift: 'Prijs arbeid zondag/feestdag (forklift)',

                Supervisor: 'Supervisor',
                Forklift: 'Forklift',
                PriceLaborSundayHoliday: 'Prijs arbeid zondag/feestdag',
                PriceLaborSaturday: 'Prijs arbeid zaterdag',

                SurchargeInHandlingSat: 'Toeslag voor handling in (zaterdag)',
                SurchargeInHandlingSun: 'Toeslag voor handling in (zondag)',
                SurchargeOutHandlingSat: 'Toeslag voor handling uit (zaterdag)',
                SurchargeOutHandlingSun: 'Toeslag voor handling uit (zondag)',

                SurchargeInHandling: 'Toeslag voor handling in',
                SurchargeOutHandling: 'Toeslag voor handling uit',
                PriceLaborSupervisor: 'Prijs arbeid supervisor',
                PriceLaborForklift: 'Prijs arbeid forklift',

                Saturday: 'Zaterdag',
                Sunday: 'Zondag',
                StartDate: 'Startdatum',
                EndDate: 'Einddatum',

                ArticleGroups: 'Artikelgroepen',
                OneArticleGroup: 'Artikelgroep',
                ArticleGroup: {
                    Name: 'Naam',
                    FixedQuantity: 'Vaste hoeveelheid (in pallets)',
                    VariableQuantity: 'Variabele hoeveelheid (in pallets)',
                    PricePerPalletFixed: 'Prijs per pallet (vast)',
                    PricePerPalletVariable: 'Prijs per pallet (variabel)',
                    PricePerPalletHandlingIn: 'Prijs per palletbehandeling (in)',
                    PricePerPalletHandlingOut: 'Prijs per palletbehandeling (uit)',
                    NoArticleGroupFound: 'Geen artikelgroepen gevonden',
                    Type: 'Type',
                    Other: 'Anders',
                },
                ExtraWorkItems: 'Extra werkitems',
                OneExtraWorkItem: 'Extra werkitem',
                ExtraWorkItem: {
                    Description: 'Beschrijving',
                    PricePerUnit: 'Prijs per eenheid',
                    Unit: 'Eenheid',
                    UnitExplanation: 'bijv. pallets, uren',
                    NoExtraWorkItemsFound: 'Geen extra werkitems gevonden',
                },
                ExtraWorkOverview: 'Extra werk overzicht',
                AddExtraWork: 'Extra werk toevoegen',
                DeleteExtraWork: 'Weet je zeker dat je dit extra werk wilt verwijderen?',
                EditExtraWork: 'Extra werk wijzigen',
                ExtraWorkEntries: {
                    Date: 'Datum',
                    ExtraWorkItem: 'Extra werkitem',
                    Quantity: 'Hoeveelheid',
                    Unit: 'Eenheid',
                    PricePerItem: 'Prijs per item',
                    TotalPrice: 'Totale prijs',
                    Remark: 'Opmerking',
                    SelectDate: 'Selecteer een datum',
                },
                SelectExtraWorkItem: 'Selecteer extra werkitem',
                NoExtraWorkFound: 'Geen extra werk gevonden',
                NoCustomerChosen: 'Geen klant gekozen',
                InvoiceLogicType: 'Welke logica gebruiken?',
            },
        },
    },
    en: {
        translation: {
            login: {
                login: 'Login',
                welcome: 'WELCOME TO THE CSE TOOL',
                credentials: 'Please fill in your credentials to login.',
                passwordForgot: 'Forgot your password?',
                loggedInAs: 'Logged in as',
                passwordReset: 'Password reset',
                passwordResetText: 'Fill in your password',
                goBackToLogin: 'Go back to login screen',
                submit: 'Save',
                passwordSaved: 'Password saved',
                passwordSavedText: 'Your new password is saved.',
                activateAccount: 'Activate account',
                activateAccountText: 'Fill in your new password.',
                send: 'Send',
                accountActivated: 'Account activated',
                accountActivatedText: 'Thank you for activating your account, you can login now',
                forgotPassword: 'Forgot password',
                forgotPasswordText: 'Fill in your email addres, we will send you an email with further instructions.',
                resendActivation: 'Resend activation mail',
                resendActivationMailSucces: 'Activation mail sent',
                emailSend: 'Email is send',
                emailSendText: 'We have send you an email with further instructions you can close this screen now.',
                username: 'Username',
                password: 'Password',
                passwordConfirm: 'Password confirm',
                chooseLanguage: 'Choose a language',
                email: 'Email',
            },
            errors: {
                RoleNotFound: 'The role could not be found. This is a server error.',
                DuplicateUserName: 'User already exists with this e-mail.',
                UserNotFound: 'User could not be found.',
                InvalidResetToken: 'This link is not valid anymore.',
                InvalidActivationToken: 'The activation link is not valid anymore.',
                WeekOrYearNotFound: 'Invalid file name, the week or year could not be read from the filename.',
                NoCSVFormat: 'The file needs to be in CSV format.',
                WrongDataFile: 'The data in the file does not have the required structure.',
                AccountBlocked: 'Your account is blocked.',
                IncorrectPassword: 'Password is incorrect.',
                PasswordRequires: 'Password requires <>',
                PasswordRequiresNonAlphanumeric: 'a special character',
                PasswordRequiresDigit: 'a number',
                PasswordRequiresUpper: 'a capital letter',
                PasswordRequiresLower: 'a small letter',
                VehicleNotFound: 'Vehicle could not be found.',
                VehicleAddFailed: 'Vehicle could not be added.',
                LicensePlateAlreadyExists: 'A vehicle with this license plate already exists.',
                LicensePlateOrMendrixIdAlreadyExists:
                    'A vehicle with this license plate or this Mendrix Id already exists.',
                MendrixIdAlreadyExists: 'A vehicle with this Mendrix Id already exists.',
                VehicleDeleteFailed: 'Vehicle could not be deleted.',
                ServerError: 'Something went wrong, please contact support.',
                SomethingWrong: 'Something went wrong',
                UnknownUserType: 'Unknown user type',
                RequiredField: 'Required field',
                InvalidEmail: 'Invalid email',
                NonidenticalPassword: 'Passwords do not match.',
                NoWeekstaten: 'Weekstaten for this week have not been generated yet!',
                NoRevenue: 'Revenues for this week have not been uploaded yet!',
                NoWeekstatenAndRevenue: 'Weekstaten and revenues for this week have not been generated/uploaded yet!',
                MailIsConfirmed: 'Email address is already confirmed.',
                EndTimeMustBeLater: 'End time should be later than the start',
                MustBePositiveNumber: 'Must be a positive number.',
                MustBeNumberGreaterOrEqualZero: 'Must be a number greater than or equal to zero.',
                MustBeIntegerGreaterOrEqualZero: 'Must be an integer greater than or equal to zero.',
                CustomerNotFound: 'Customer could not be found.',
                CouldNotUpdateCustomer: 'Customer could not be updated.',
                CustomerAlreadyExists: 'A customer with this Id already exists.',
                CouldNotAddCustomer: 'Customer could not be added.',
                NoArticleGroupsInCustomer:
                    "Customer {{name}} doesn't have any Article Groups. To upload data, first add an Article Group.",
                NoCanArticleGroupsInCustomer:
                    'There is no corresponding Article Groups with type "Cans" on {{date}}. Please, add an Article Group first or change the start/end date.',
                NoEndArticleGroupsInCustomer:
                    'There is no corresponding Article Groups with type "Ends" on {{date}}. Please, add an Article Group first or change the start/end date.',
                MaterialDescriptionNotFound:
                    "The material description {{materialDescription}} doesn't correspond to any conventional material descriptions. In the upload file, please check cell F{{row}}.",
                NoArticleGroupsForMaterial:
                    'There is no corresponding Article Group for material {{materialDescription}}. Check cell F{{row}} in the uploaded file or add the corresponding Article Group',
                NoDateFound: 'Date could not be found in the file.',
                WrongPlantName: 'The plant name in this file does not match the customer.',
                UnknownDataFormat: 'We could not determine which kind of file you tried to upload.',
                CouldNotDeleteArticleGroup:
                    'It is not possible to delete {{AGName}} article group, as there is data linked to it.',
                CouldNotChangeArticleGroupStartDate:
                    'Some data of {{AGName}} article group is linked to an earlier date - {{earliestDateLinkedToAG}} - than you have entered.',
                CouldNotChangeArticleGroupEndDate:
                    'Some data of {{AGName}} article group is linked to later date - {{latestDateLinkedToAG}} - than you have entered.',
                MustBeInsideEwiValidityPeriod:
                    'The date must fall within the validity period for the chosen extra work item: from {{EWIStartDate}} to {{EWIEndDate}}.',
                ExtraWorkEntryNotFound: 'The extra work entry could not be found.',
                CouldNotDeleteExtraWorkItem:
                    'It is not possible to delete this extra work item, as there is data linked to it.',
                CouldNotChangeExtraWorkItemStartDate:
                    'There are some data entries for {{EWIDescription}} extra work item that are linked to an earlier date - {{eariestEntryDate}} - than you have entered.',
                CouldNotChangeExtraWorkItemEndDate:
                    'There are some data entries for {{EWIDescription}} extra work item that are linked to an later date - {{latestEntryDate}} - than you have entered.',
                ThisDateOverlapWithAG: 'This date causes overlap with article group {{OtherAGName}}.',
                NoXlsxFile: 'File was not in .xlsx format',
                CouldNotGetInformationFromTLN: 'Could not get information from TLN',
                MissingTLNResponse:
                    'There is a problem with the location data of the following vehicles: {{formattedVehicles}}',
                MissingTLNResponseEntry: '{{number}}, order {{orderKey}} at {{date}}',
            },
            explanations: {
                MendriX:
                    'Retrieve all the necessary information from MendriX (be mindful that the data of the past week will only be available from Tuesday on).',
                JustNeedsExcel: 'The files need to be .xlsx-files',
                JustNeedsOneExcel: 'The file needs to be .xlsx-file',
                JustNeedsSomeExcel: 'The files need to be .xlx or .xlsx-files',
                DownloadAllResults:
                    'Here you can download all result files: weekstaten, result overview, summary and kilometer summary. This is only possible if the data of the relevant weeks have been retrieved',
                DownloadStilstand: 'Here you can download the downtime of a chosen year.',
                UploadTemplateFiles: 'Please upload some template files below',
                UploadExportStilstandTemplateFile: 'Please upload export stationary template file below',
                ValidationErrors:
                    'There are one or more vehicles with validation errors. These vehicles will not be saved',
                UploadMovementsAndStock: 'Please upload stock and movements files',
                DownloadWeekendHours: 'Here you can download the weekend hours for a chosen period.',
            },
            roles: {
                Admin: 'Admin',
                TransportPL: 'TransportPL',
                TransportPlanning: 'TransportPlanning',
                TransportNL: 'TransportNL',
                Warehousing: 'Warehousing',
            },
            statuses: {
                Pending: 'Pending',
                Active: 'Active',
                Blocked: 'Blocked',
            },
            general: {
                MendriX: 'MendriX',
                VariableOverview: 'Variable overview',
                Revenue: 'Revenue',
                VehicleRevenues: 'Vehicle revenue overview',
                Comparison: 'Compare',
                ComparisonTitle: 'Kilometerstaten with Rittenlijsten comparison',
                Normalize: 'Normalize',
                CseTool: 'CSE Tool',
                Loading: 'Loading...',
                Save: 'Save',
                Variables: 'Variables',
                Cancel: 'Cancel',
                Submit: 'Submit',
                Confirm: 'Confirm',
                Users: 'Users',
                Weekstaten: 'Weekstaten',
                Vehicles: 'Vehicles',
                VehicleOvertimes: 'Weekend hours',
                StationaryTool: 'Stationary',
                Warehousing: 'Warehousing',
                ChangesSaved: 'Changes saved',
                ChangesNotSaved: 'Changes could not be saved',
                Till: 'Till',
                Saturday: 'Saturday',
                Sunday: 'Sunday',
                Holidays: 'Holidays',
                NotesAdmin: 'Notes NL',
                NotesUser: 'Notes PL',
                Total: 'Total',
                SelectWeek: 'Select week',
                SelectMonth: 'Select month',
                SelectYear: 'Select year',
                Search: 'Search',
                Busy: 'Busy...',
                Generate: 'Generate',
                And: 'And',
                Page: 'Page',
                Of: 'of',
                Refresh: 'Refresh',
                Time: 'Time',
                ForExampleAbbr: 'e.g.',
                Month: 'Month',
            },
            variables: {
                Variable: 'Variabele',
                Value: 'Value',
                Type: 'Type',
                NoVariablesFound: 'No variabele found',
                types: {
                    Currency: 'Currency',
                },
                names: {
                    DrivenDayTariffTruck: 'Driven day tariff truck',
                    DrivenDayTariffCombi: 'Driven day tariff combi',
                    NonDrivenDayTariffTruck: 'Non driven day tariff truck',
                    NonDrivenDayTariffCombi: 'Non driven day tariff combi',
                    WeekendHoursTariff: 'Weekend hours tariff',
                },
            },
            user: {
                AddUser: 'Add user',
                EditUser: 'Edit user',
                UserOverview: 'User overview',
                FirstName: 'Firstname',
                LastName: 'Surname',
                FullName: 'Fullname',
                Role: 'Role',
                Status: 'Status',
                NoUsersFound: 'No users found',
                Email: 'Email',
                SelectRole: 'Select role',
            },
            vehicle: {
                Vehicle: 'Vehicle',
                Charter: 'Charter',
                Dutch: 'Dutch',
                Polish: 'Polish',
                AddVehicle: 'Add vehicle',
                EditVehicle: 'Edit vehicle',
                VehicleOverview: 'Vehicle overview',
                Number: 'Vehicle number',
                LicensePlate: 'License plate',
                Type: 'Type',
                NoVehiclesFound: 'No vehicles found',
                ConfirmDelete: 'Are you sure you want to delete this vehicle?',
                NoVehicleChosen: 'No vehicle chosen',
                VolumeType: 'Volume type',
                Truck: 'Truck',
                Combi: 'Combi',
                ExemptedGermanToll: 'Exempted of German toll',
            },
            weekstaten: {
                GenerateWeekstaten: 'Generate weekstaten',
                UploadRittenlijst: 'Upload rittenlijsten',
            },
            resultsOverview: {
                GenerateResultsOverview: 'Generate result overview',
                GenerateSummaryPerWeek: 'Generate summary per week',
                UploadResultsFile: 'Upload result file',
            },
            kms: {
                UploadKmsFile: 'Upload kilometer summary template',
            },
            kilometerstaten: {
                UploadOmzetlijst: 'Upload omzetlijst',
                NormalizeKS: 'Normalize kilometerstaten',
            },
            vehicleRevenue: {
                UploadOmzetlijst: 'Upload "omzetlijst"',
                GenerateTurnover: 'Generate vehicle turnovers',
                OrderKey: 'Order #',
                RelationName: 'Relation name',
                FirstTaskPlace: 'Place, first task',
                FirstTaskPostalCode: 'Postalcode, first task',
                FirstTaskTimestamp: 'Timestamp, first task',
                LastTaskTimestamp: 'Timestamp, last task ',
                LastTaskPlace: 'Place, last task',
                LastTaskPostalCode: 'Postalcode, last task',
                NumberOfTasks: 'Number of tasks',
                PurchaseCost: 'Purchase cost',
                PurchaseCostExclBTW: 'Purchase cost excl. FAT',
                PurchaseCostExclBTWLeft: 'Left',
                Total: 'total',
            },
            stilstand: {
                Number: 'Vehicle number',
                LicensePlate: 'License plate',
                Monday: 'Monday',
                Tuesday: 'Tuesday',
                Wednesday: 'Wednesday',
                Thursday: 'Thursday',
                Friday: 'Friday',
                Saturday: 'Saturday',
                Sunday: 'Sunday',
                SelectAVehicle: 'Select a vehicle',
                SpecialNotes: 'Extra / special remarks',
                SelectStandartReason: 'Select standard reason',
            },
            mendrix: {
                RetrieveDataShort: 'Retrieve data',
                RetrieveData: 'Retrieve all the necessary information from MendriX',
                CheckStatus: 'Check MendriX status',
                TerminateRetrieval: 'Stop retrieval of data',
                SomethingWentWrong: 'Something went wrong',
                CancelledByUser: 'Cancelled by user',
                Failed: 'Failed',
                Starting: 'Starting',
                Finished: 'Finished',
            },
            warehousing: {
                tabs: {
                    InformatieTab: 'Information',
                    UploadTab: 'Uploads',
                    DownloadTab: 'Downloads',
                    ExtraWorkTab: 'Extra work',
                },
                UploadFile: 'Upload file',
                UploadStockFile: 'Upload stock file',
                Import: 'Import',
                ImportSuccessful: 'The import was successful',
                timeline: {
                    title: 'Timeline',
                    error: 'Something went wrong while loading the timeline',
                    viewAllChanges: 'View all changes',
                    hideChanges: 'Hide changes',
                    to: 'to',
                    categories: {
                        Downloads: 'Downloads',
                        Uploads: 'Uploads',
                        Customers: 'Customers',
                        ExtraWorkEntries: 'Extra work',
                        Notes: 'Notes',
                    },
                    customNote: {
                        addNote: 'Add note',
                        placeholder: 'Type your note here...',
                        error: 'Something went wrong while adding the note',
                    },
                    CustomerAdded: {
                        title: 'Customer <strong>{{name}}</strong> was added.',
                    },
                    CustomerDeleted: {
                        title: 'Customer <strong>{{name}}</strong> was deleted.',
                    },
                    CustomerUpdated: {
                        title: 'The following fields of customer <strong>{{name}}</strong> were edited:',
                        fields: {
                            Added: 'was added',
                            Updated: 'was updated',
                            Deleted: 'was deleted',

                            Name: 'Name',
                            Address: 'Address',
                            PlantName: 'Location code',
                            InvoiceLogicType: 'Invoice logic type',
                            PriceLaborSaturdaySupervisor: 'Price labor saturday (supervisor)',
                            PriceLaborSundayHolidaySupervisor: 'Price labor sunday/holiday (supervisor)',
                            PriceLaborSaturdayForklift: 'Price labor saturday (forklift)',
                            PriceLaborSundayHolidayForklift: 'Price labor sunday/holiday (forklift)',
                            SurchargeInHandlingSat: 'Surcharge for handling in (Saturday)',
                            SurchargeInHandlingSun: 'Surcharge for handling in (Sunday)',
                            SurchargeOutHandlingSat: 'Surcharge for handling out (Saturday)',
                            SurchargeOutHandlingSun: 'Surcharge for handling out (Sunday)',

                            ArticleGroup: 'Article group',
                            ArticleGroupType: 'Type',
                            StartDate: 'Start date',
                            EndDate: 'End date',
                            FixedQuantity: 'Fixed quantity (in pallets)',
                            VariableQuantity: 'Variable quantity (in pallets)',
                            PricePerPalletFixed: 'Price per pallet (fixed)',
                            PricePerPalletVariable: 'Price per pallet (variable)',
                            PricePerPalletHandlingIn: 'Price per pallet handling (in)',
                            PricePerPalletHandlingOut: 'Price per pallet handling (out)',

                            ExtraWorkItem: 'Extra work item',
                            Description: 'Description',
                            PricePerUnit: 'Price per unit',
                            Unit: 'Unit',
                        },
                    },
                    DocumentDownloaded: {
                        title: 'Document <fileLink>{{name}}</fileLink> was downloaded.',
                    },
                    DocumentUploaded: {
                        title: 'Document <strong><fileLink>{{name}}</fileLink></strong> was uploaded for customer <strong>{{customer}}</strong>. It contained <strong>{{dataCount}}</strong> records between <strong>{{fromDate}}</strong> and <strong>{{toDate}}</strong>.',
                    },
                    ExtraWorkEntryAdded: {
                        title: 'Data for extra work item <strong>{{extraWorkItem}}</strong> was added:',
                    },
                    ExtraWorkEntryDeleted: {
                        title: 'Data for extra work item <strong>{{extraWorkItem}}</strong> was deleted:',
                    },
                    ExtraWorkEntryUpdated: {
                        title: 'Data for extra work item <strong>{{extraWorkItem}}</strong> was edited:',
                        fields: {
                            ExtraWorkItem: 'Extra work item',
                            Timestamp: 'Date',
                            Quantity: 'Quantity',
                            Remark: 'Remark',
                        },
                    },
                },
                downloads: {
                    export: {
                        description: 'Export data for customer <strong>{{name}}</strong> within the selected period.',
                        fromDate: 'From date (inclusive)',
                        toDate: 'To date (inclusive)',
                        export: 'Export',
                    },
                },
            },
            customer: {
                AddCustomer: 'Add customer',
                ExportAllCustomers: 'Export all customers',
                EditCustomer: 'Edit customer',
                Name: 'Name',
                PlantName: 'Location code',
                PriceLaborSaturdaySupervisor: 'Price labor saturday (supervisor)',
                PriceLaborSundayHolidaySupervisor: 'Price labor sunday/holiday (supervisor)',
                PriceLaborSaturdayForklift: 'Price labor saturday (forklift)',
                PriceLaborSundayHolidayForklift: 'Price labor sunday/holiday (forklift)',

                Supervisor: 'Supervisor',
                Forklift: 'Forklift',
                PriceLaborSundayHoliday: 'Price labor sunday/holiday',
                PriceLaborSaturday: 'Price labor saturday',

                SurchargeInHandlingSat: 'Surcharge for handling in (Saturday)',
                SurchargeInHandlingSun: 'Surcharge for handling in (Sunday)',
                SurchargeOutHandlingSat: 'Surcharge for handling out (Saturday)',
                SurchargeOutHandlingSun: 'Surcharge for handling out (Sunday)',

                SurchargeInHandling: 'Surcharge for handling in',
                SurchargeOutHandling: 'Surcharge for handling out',
                PriceLaborSupervisor: 'Price labor supervisor',
                PriceLaborForklift: 'Price labor forklift',

                Saturday: 'Saturday',
                Sunday: 'Sunday',
                StartDate: 'Start date',
                EndDate: 'End date',

                ArticleGroups: 'Article groups',
                OneArticleGroup: 'Article group',
                ArticleGroup: {
                    Name: 'Name',
                    FixedQuantity: 'Fixed quantity (in pallets)',
                    VariableQuantity: 'Variable quantity (in pallets)',
                    PricePerPalletFixed: 'Price per pallet (fixed)',
                    PricePerPalletVariable: 'Price per pallet (variable)',
                    PricePerPalletHandlingIn: 'Price per pallet handling (in)',
                    PricePerPalletHandlingOut: 'Price per pallet handling (out)',
                    NoArticleGroupFound: 'No article groups found',
                    Type: 'Type',
                    Other: 'Other',
                },
                ExtraWorkItems: 'Extra work items',
                OneExtraWorkItem: 'Extra work item',
                ExtraWorkItem: {
                    Description: 'Description',
                    PricePerUnit: 'Price per unit',
                    Unit: 'Unit',
                    UnitExplanation: 'e.g. pallets, hours',
                    NoExtraWorkItemsFound: 'No extra work items found',
                },
                ExtraWorkOverview: 'Extra work overview',
                AddExtraWork: 'Add extra work',
                DeleteExtraWork: 'Are you sure you want to delete this extra work?',
                EditExtraWork: 'Update extra work',
                ExtraWorkEntries: {
                    Date: 'Date',
                    ExtraWorkItem: 'Extra work item',
                    Quantity: 'Quantity',
                    Unit: 'Unit',
                    PricePerItem: 'Price per item',
                    TotalPrice: 'Total price',
                    Remark: 'Remark',
                    SelectDate: 'Select a date',
                },
                SelectExtraWorkItem: 'Select extra work item',
                NoExtraWorkFound: 'No extra work found',
                NoCustomerChosen: 'No customer chosen',
                InvoiceLogicType: 'Which invoice logic to use?',
            },
        },
    },
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',

        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'i18nextLng',
        },
    });

export default i18n;
